export const SET_CUSTOMER_DATA = "SET_CUSTOMER_DATA";
export const SET_ASSIGNMENT_DATA = "SET_ASSIGNMENT_DATA";